/*
 * Frontend Entry Point
 *
 * Features:
 * - Mounts the React application in Strict Mode
 * - Provides one application-scoped TanStack Query cache
 *
 * Changes:
 * - 2026-08-06: Added the shared server-state Query client provider
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import { queryClient } from './query/queryClient';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
